/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import BaseWrapper from '../../../components/base-wrapper';

export default function save( props ) {
	const { className, attributes } = props;
	const { blockClientId } = attributes;

	const wrapperClasses = classnames(
		className,
		'gutenify-team-item',
		`gutenify-section-${ blockClientId }`,
	);

	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props } name="gutenify/team-member">
				<InnerBlocks.Content />
			</BaseWrapper>
		</div>
	);
}

